import {  Timeline } from "flowbite-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Drawer } from "../../../../components/Modals";
import { useJwt } from "../../../../helpers/common";
import { getTimeZoneDate } from "../../../../helpers/data-format";
import { useProjectService } from '../../../../services';

const ViewHistoryModal = ({
            showViewHistoryModal,
            closeViewHistoryModal,
            projectId
        }:any) =>{
        const JWTdata: any = useJwt()
        const org_id = JWTdata.org_id;
        
        const { fetchProjectHistory } = useProjectService();
        const {projectHistoryLoading,projectHistory} = useSelector((state: any) => state.projects);
        const { entity_type } = useSelector((state: any) => state.roadmap);

        useEffect(()=>{
            if(projectId){
                fetchProjectHistory(projectId)
            }
        },[projectId])

        // Function to safely render HTML content
        const renderHTML = (htmlContent: string) => {
            return { __html: htmlContent || '' };
        };

        // Function to sanitize action_type by converting snake_case to Title Case
        const sanitizeActionType = (actionType: string) => {
            if (!actionType) return '';
            return actionType
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        };
        
    return (
        <Drawer
          isOpen={showViewHistoryModal}
          onClose={closeViewHistoryModal}
          position="right"
        >
            <div className="relative h-[calc(100%-55px)] overflow-auto flex flex-col bg-light-surface dark:bg-tertiary-dark">
                {/* Enhanced Header */}
                <div className="flex flex-row border-b rounded-b-2xl border-light-border-default dark:border-gray-600 bg-light-surfacePrimary dark:bg-secondary-dark sticky top-0 z-40 px-6 py-4">
                    <div className="flex w-full items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <div className="w-8 h-8 rounded-lg bg-primary-light/10 dark:bg-primary-dark/20 flex items-center justify-center">
                                <svg className="w-4 h-4 text-primary-light dark:text-primary-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div>
                                <h2 className="text-light-text-primary dark:text-white text-lg font-semibold">{entity_type.charAt(0).toUpperCase() + entity_type.slice(1)} History</h2>
                                <p className="text-light-text-tertiary dark:text-gray-400 text-sm">Track all {entity_type.toLowerCase()} changes</p>
                            </div>
                        </div>
                        <button 
                            type="button" 
                            className="w-8 h-8 rounded-lg bg-light-surface hover:bg-light-surfaceHover dark:bg-gray-700 dark:hover:bg-gray-600 
                                     flex items-center justify-center text-light-text-secondary dark:text-gray-300 
                                     transition-colors duration-200 border border-light-border-subtle dark:border-gray-600"
                            onClick={closeViewHistoryModal}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Content Area */}
                <div className="flex-1 p-6">
                    {projectHistory && projectHistory.length > 0 ? (
                        <div className="space-y-1">
                            <Timeline 
                                theme={{
                                    root: {
                                        direction: {
                                            vertical: "relative border-l-2 border-light-border-subtle dark:border-gray-600"
                                        }
                                    }
                                }}
                            >
                                {projectHistory.map((his: any, index: number) => {
                                    return (
                                        <div key={index} className="group">
                                            <Timeline.Item className="!dark:border-gray-200 pb-6">
                                                <Timeline.Point 
                                                    theme={{
                                                        marker: {
                                                            base: {
                                                                vertical: "absolute left-[-7px] mt-2 h-3.5 w-3.5 rounded-full border-2 border-light-surfacePrimary dark:border-gray-800 bg-primary-light dark:bg-primary-dark shadow-sm"
                                                            }
                                                        }
                                                    }} 
                                                />
                                                <Timeline.Content>
                                                    <div className="bg-light-surfacePrimary dark:bg-secondary-dark rounded-xl p-4 ml-4 
                                                                  border border-light-border-subtle dark:border-gray-600 
                                                                  group-hover:border-light-border-emphasis dark:group-hover:border-gray-500 
                                                                  transition-all duration-200 shadow-sm hover:shadow-md">
                                                        <Timeline.Title className="flex items-start space-x-3 mb-3">
                                                            <div className="flex-1">
                                                                <div className="flex items-center space-x-2 mb-2">
                                                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium 
                                                                                   bg-light-status-info-bg dark:bg-blue-900/30 
                                                                                   text-light-status-info-text dark:text-blue-300 
                                                                                   border border-light-status-info-border dark:border-blue-800">
                                                                        {sanitizeActionType(his?.action_type)}
                                                                    </span>
                                                                </div>
                                                                <div className="text-light-text-primary dark:text-white text-sm font-medium leading-relaxed">
                                                                    {his?.query_description ? 
                                                                        (his.query_description.startsWith('<') ? 
                                                                            <span dangerouslySetInnerHTML={renderHTML(his.query_description)} /> : 
                                                                            <span className="break-words">{his.query_description}</span>
                                                                        ) : 
                                                                        <span className="text-light-text-muted dark:text-gray-400 italic">No description available</span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Timeline.Title>
                                                        <Timeline.Time className="ml-0">
                                                            <div className="flex items-center space-x-2 text-light-text-tertiary dark:text-gray-400 text-xs">
                                                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                                </svg>
                                                                <span>
                                                                    {getTimeZoneDate(his?.created_at, 'llll') as string}
                                                                </span>
                                                            </div>
                                                        </Timeline.Time>
                                                    </div>
                                                </Timeline.Content>
                                            </Timeline.Item>
                                        </div>
                                    )
                                })}
                            </Timeline>
                        </div>
                    ) : (
                        !projectHistoryLoading && (
                            <div className="flex flex-col items-center justify-center h-64 text-center">
                                <div className="w-16 h-16 rounded-full bg-light-surface dark:bg-gray-700 flex items-center justify-center mb-4">
                                    <svg className="w-8 h-8 text-light-text-muted dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-light-text-secondary dark:text-gray-300 text-lg font-medium mb-2">No History Available</h3>
                                <p className="text-light-text-muted dark:text-gray-400 text-sm max-w-sm">
                                    This {entity_type.toLowerCase()} doesn't have any recorded history yet. Changes will appear here as they happen.
                                </p>
                            </div>
                        )
                    )}
                </div>

                {/* Skeleton Loading State */}
                {projectHistoryLoading && (
                    <div className="absolute inset-0 bg-light-surface dark:bg-tertiary-dark z-50">
                        {/* Static Header - Same as actual header */}
                        <div className="flex flex-row border-b rounded-b-2xl border-light-border-default dark:border-gray-600 bg-light-surfacePrimary dark:bg-secondary-dark sticky top-0 z-40 px-6 py-4">
                            <div className="flex w-full items-center justify-between">
                                <div className="flex items-center space-x-3">
                                    <div className="w-8 h-8 rounded-lg bg-primary-light/10 dark:bg-primary-dark/20 flex items-center justify-center">
                                        <svg className="w-4 h-4 text-primary-light dark:text-primary-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h2 className="text-light-text-primary dark:text-white text-lg font-semibold">{entity_type.charAt(0).toUpperCase() + entity_type.slice(1)} History</h2>
                                        <p className="text-light-text-tertiary dark:text-gray-400 text-sm">Track all {entity_type.toLowerCase()} changes</p>
                                    </div>
                                </div>
                                <button 
                                    type="button" 
                                    className="w-8 h-8 rounded-lg bg-light-surface hover:bg-light-surfaceHover dark:bg-gray-700 dark:hover:bg-gray-600 
                                             flex items-center justify-center text-light-text-secondary dark:text-gray-300 
                                             transition-colors duration-200 border border-light-border-subtle dark:border-gray-600"
                                    onClick={closeViewHistoryModal}
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Skeleton Content */}
                        <div className="flex-1 p-6">
                            <div className="space-y-1">
                                <div className="relative border-l-2 border-light-border-subtle dark:border-gray-600">
                                    {/* Generate 3 skeleton timeline items */}
                                    {[1, 2, 3,4,5,6,7,8,9,10].map((index) => (
                                        <div key={index} className="group pb-6">
                                            <div className="flex">
                                                {/* Timeline Point Skeleton */}
                                                <div className="absolute left-[-7px] mt-2 h-3.5 w-3.5 rounded-full border-2 border-light-surfacePrimary dark:border-gray-800 
                                                              bg-gray-300 dark:bg-gray-600 animate-pulse shadow-sm"></div>
                                                
                                                {/* Timeline Content Skeleton - Same styling as real content */}
                                                <div className="bg-light-surfacePrimary dark:bg-secondary-dark rounded-xl p-4 ml-4 w-full
                                                              border border-light-border-subtle dark:border-gray-600 
                                                              group-hover:border-light-border-emphasis dark:group-hover:border-gray-500 
                                                              transition-all duration-200 shadow-sm hover:shadow-md">
                                                    {/* Badge Skeleton */}
                                                    <div className="flex items-center space-x-2 mb-3">
                                                        <div className="h-5 w-24 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div>
                                                    </div>
                                                    
                                                    {/* Description Skeleton */}
                                                    <div className="space-y-2 mb-4">
                                                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-full"></div>
                                                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-3/4"></div>
                                                        {index === 1 && <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-1/2"></div>}
                                                    </div>
                                                    
                                                    {/* Timestamp Skeleton */}
                                                    <div className="flex items-center space-x-2">
                                                        <div className="w-3.5 h-3.5 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                        <div className="h-3 w-40 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Drawer>
    )
}

export default ViewHistoryModal;